/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Users_Update_FailedInputs */

const en_users_update_failed = /** @type {(inputs: Users_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update user: ${i?.message}`)
};

const pt_br2_users_update_failed = /** @type {(inputs: Users_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar usuário: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Failed to update user: {message}" |
*
* @param {Users_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_update_failed = /** @type {((inputs: Users_Update_FailedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Update_FailedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_update_failed(inputs)
	return pt_br2_users_update_failed(inputs)
});